import {
    ComboBoxChangeEvent,
    ComboBoxFilterChangeEvent,
    ListItemProps,
    MultiColumnComboBox,
} from "@progress/kendo-react-dropdowns"

import {Popup} from "@progress/kendo-react-popup"
import {debounce} from "lodash"
import {MDBCol, MDBRow} from "mdbreact"
import React, {useRef, useState} from "react"
import {
    BookingDetail,
    Customer,
    fetchCustomerContactReminderList,
    fetchCustomers,
    setCustomers,
} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"
import CustomerContactAddEdit from "../../Customer/CustomerContactGrid"

const CustomerPackagesMultiCombo = ({
    customer,
    booking,
    updateBookingDetail,
}: {
    customer: Customer | null
    booking: BookingDetail
    updateBookingDetail: (bookingDetail: BookingDetail, includeFields: boolean) => void
}) => {
    const dispatch = useAppDispatch()
    const gettingCustomers = useAppSelector((state: RootState) => state.containers.motBooking.gettingCustomers)
    const customersData = useAppSelector((state: RootState) => state.containers.motBooking.customers)

    const [show, setShow] = useState(false)

    const anchor = useRef<any>()
    const contentRef = useRef<any>()
    const blurTimeoutRef = useRef<any>()

    const onOpenSchPopover = () => {
        contentRef.current.focus()
    }

    const onFocusSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
    }

    const onBlurSchPopover = () => {
        clearTimeout(blurTimeoutRef.current)
        blurTimeoutRef.current = setTimeout(onBlurTimeout, 100)
    }

    const onBlurTimeout = () => {
        setShow(false)
    }

    const showCustomerContacts = () => {
        setShow(!show)
    }

    const columns = [
        {
            field: "accountNo",
            header: "Account No",
            width: "150px",
        },
        {
            field: "companyName",
            header: "Company Name",
            width: "400px",
        },
        {
            field: "city",
            header: "City",
            width: "200px",
        },
    ]

    const columnItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const children = columns.map((col, i) => {
            return (
                <span className="k-table-td" style={{width: col.width}} key={i}>
                    {itemProps.dataItem[col.field]}
                </span>
            )
        })
        return React.cloneElement(li, {...li.props}, children)
    }

    const onCustomerSearch = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            if (event.filter?.value?.length > 2) {
                customerSearchDebounce(event.filter.value)
            }
        }
    }

    const customerSearchDebounce = debounce(nextValue => dispatch(fetchCustomers(nextValue)), 500)

    const onCustomerSelect = (ev: ComboBoxChangeEvent) => {
        const selected = ev.value as Customer

        let bkdt = booking
        if (selected == null) {
            bkdt = {
                ...booking,
                customerID: 0,
                accountNo: "",
                companyName: "",
                customer: null,
                recipients: "",
                email: "",
                phone: "",
                sendReminderEmail: true,
            }
        } else if (selected.customerId === undefined) {
            let noCustID = {} as Customer
            noCustID.customerId = -1
            noCustID.accountNo = ""
            noCustID.companyName = selected.displayName
            noCustID.displayName = selected.displayName
            bkdt = {
                ...booking,
                customerID: 0,
                accountNo: "",
                companyName: selected.displayName,
                customer: noCustID,
            }
        } else {
            //Reset Contact on change
            bkdt = {
                ...booking,
                customerID: selected.customerId,
                accountNo: selected.accountNo,
                companyName: selected.companyName,
                customer: selected,
                recipients: "",
                email: "",
                phone: "",
            }
        }
        updateBookingDetail(bkdt, false)
        if (bkdt.customerID > 0) {
            dispatch(fetchCustomerContactReminderList(bkdt, bkdt.customerID))
        }
    }

    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-end",
                }}
            >
                <MultiColumnComboBox
                    required
                    validationMessage="Select a customer"
                    valid={booking.companyName.length > 0}
                    allowCustom={true}
                    name={"companyName"}
                    value={customer}
                    textField="displayName"
                    dataItemKey="companyName"
                    data={customersData}
                    columns={columns}
                    label={"Customer"}
                    itemRender={columnItemRender}
                    filterable={true}
                    loading={gettingCustomers}
                    onFilterChange={onCustomerSearch}
                    onChange={onCustomerSelect}
                    onFocus={(ev: any) => {
                        if (ev.value === null) dispatch(setCustomers([]))
                    }}
                    // onOpen={() => customer && dispatch(fetchCustomers(customer?.companyName))}
                />
                <button
                    type="button"
                    className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-primary"
                    disabled={booking.customerID <= 0}
                    onClick={showCustomerContacts}
                    ref={anchor}
                >
                    <span className="fa fa-users"></span>
                </button>
                <Popup
                    anchor={anchor.current}
                    anchorAlign={{
                        horizontal: "right",
                        vertical: "bottom",
                    }}
                    popupAlign={{
                        horizontal: "right",
                        vertical: "top",
                    }}
                    show={show}
                    onOpen={onOpenSchPopover}
                    popupClass={"popup-content"}
                >
                    <div
                        style={{width: "1000px"}}
                        ref={contentRef}
                        tabIndex={0}
                        onFocus={onFocusSchPopover}
                        onBlur={onBlurSchPopover}
                    >
                        {booking.customerID > 0 && (
                            <div>
                                <MDBRow>
                                    <MDBCol md="12">
                                        <CustomerContactAddEdit
                                            customerId={booking.customerID}
                                            enableEdit={true}
                                            booking={booking}
                                            onBlur={onBlurSchPopover}
                                        />
                                    </MDBCol>
                                </MDBRow>
                            </div>
                        )}
                    </div>
                </Popup>
            </div>
        </>
    )
}

export default React.memo(CustomerPackagesMultiCombo)
